module.exports = "/images/twitter-icon.svg";